import React, { useState } from 'react';
import rsv from 'rsv';

import BouncyDue from '../../images/due_gifs/BouncyDue.gif'
import CryingDue from '../../images/due_gifs/CryingDue.gif'
import FlappingDueUtil from '../../images/due_gifs/FlappingDueUtil.gif'
import GlitchDue from '../../images/due_gifs/GlitchDue.gif'
import ProgressionDue from '../../images/due_gifs/ProgressionDue.gif'
import ThnkingDue from '../../images/due_gifs/ThnkingDue.gif'
import TransformDue from '../../images/due_gifs/TransformDutil02.gif'

const DUES = [
  /*BouncyDue, CryingDue*/ FlappingDueUtil, GlitchDue,
  ProgressionDue, ThnkingDue, TransformDue
];

const RandomDue = () => {
  const [due, _] = useState(rsv(...DUES))
  return (
    <div className="random-due">
    <img src={due} alt={"Due"}/>
    </div>);
}

export default RandomDue;
